
<div class="form-group">
    <label class="ngp-field-label">{{title}}</label>
    <input type="date" class="form-control ngp-field ngp-field-text-left"
    (change)="valueChange.emit(value)"
    [(ngModel)]="value"
    >
    <p *ngIf="errorText" class="ngp-error-input">{{errorText}}</p>
</div>
